/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
import React, {useState, useEffect, useCallback} from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCog, faEye, faFileInvoiceDollar, faFunnelDollar, faHome, faImage, faRecycle, faSearch } from '@fortawesome/free-solid-svg-icons';
import { Modal, Col, Row, Form, Button, ButtonGroup, Breadcrumb, InputGroup, Dropdown, Card, Table} from '@themesberg/react-bootstrap';

import { useDispatch, useSelector } from "react-redux"
import NewBundleSheetPage from "./NewBundleSheetPage";
import BundleAction from "../../core/redux/action/BundleAction";
import AppConfig from "../../core/config/AppConfig";
const moment = require('moment');
import PuPagination from "../../components/PuPagination"
import { GetResultObject, PostRequest } from "../../core/API";
import { ApiSrc } from "../../resources/ApiSrc";
import { currencyFormat, nameFormat, phoneFormat } from "../../core/util/General";
import { BundleStatus } from "./BundleSheetPage";
import { WaybillStatus, WaybillStatusType } from "../waybills/WaybillPage"
import Swal from 'sweetalert2'
import MapView from "../../components/map";
import { Marker } from "react-google-maps"
const marker = require('../../components/map/placeholder.svg');
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

export default (props) => {

  const [bundle, setBundle] = useState()
  const [logs, setLogs] = useState()
  const [additionalFee, setAdditionalFee] = useState(0)
  const [showRefund, setShowRefund] = useState(false)
  const [item, setItem] = useState()
  const [photo, setPhoto] = useState()

  const escFunction = useCallback((event) => {
    if (event.keyCode === 27) {        
        props.onClose && props.onClose()
    }    
  }, [props]);

  useEffect(() => {
      document.addEventListener("keydown", escFunction, false);

      return () => {
          document.removeEventListener("keydown", escFunction, false);
      };
  }, [escFunction]);

  useEffect(()=>{
    fetchData()
  }, [])

  const fetchData = () => {
    PostRequest(ApiSrc.GET_BUNDLE_DETAIL, {
      token: "",
      input: {id: _.get(props, 'id')}
    }).then(result => {
      GetResultObject(result, 'data', 200, (data) => {
        setBundle(data)
      })
    })

    PostRequest(ApiSrc.GET_BUNDLE_LOG_LIST, {
      token: "",
      input: {id: _.get(props, 'id')}
    }).then(result => {
      GetResultObject(result, 'data', 200, (data) => {
        setLogs(data)
      })
    })
  };

  const refund = () => {
    PostRequest(ApiSrc.REFUND_BUNDLE, {
      input: {
        id: _.get(bundle, 'id'),
        waybillIds: [_.get(item, 'waybill.id')],        
        additionalFee
      }
    }).then(result => {
      GetResultObject(result, 'data', 200, (data) => {
        setBundle(data)
        setItem(undefined)
        setShowRefund(false)
    })
    })
  }

  if(bundle == undefined)
  return (
    <Card>
    <Card.Body><Form.Label>Loading</Form.Label></Card.Body>
    </Card>
  )
  
  return (
    <>
      {
          photo && (
            <Lightbox
              mainSrc={photo}
              // nextSrc={images[(photoIndex + 1) % images.length]}
              // prevSrc={images[(photoIndex + images.length - 1) % images.length]}
              onCloseRequest={() => setPhoto(undefined)}
              // onMovePrevRequest={() =>
              //   this.setState({
              //     photoIndex: (photoIndex + images.length - 1) % images.length,
              //   })
              // }
              // onMoveNextRequest={() =>
              //   this.setState({
              //     photoIndex: (photoIndex + 1) % images.length,
              //   })
              // }
            />
          )
        }
      <React.Fragment>
      <Modal as={Modal.Dialog} centered show={showRefund} onHide={()=>{setShowRefund(false)}}>
        <Modal.Header>
          <Modal.Title className="h6">Input additional fee</Modal.Title>
          <Button variant="close" aria-label="Close" onClick={()=>{setShowRefund(false)}} />
        </Modal.Header>
        <Modal.Body>
          <input onChange={(e) => setAdditionalFee(e.target.value)} min={0} type='number' step='0.001' className={'form-control'} value={additionalFee}/>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={()=>{refund()}}>
              Refund
          </Button>
            <Button variant="link" className="text-gray ms-auto" onClick={()=>{setShowRefund(false)}}>
              Close
          </Button>
        {/* refund(item) */}
        </Modal.Footer>
      </Modal>
    </React.Fragment>
      <Card>
              
        <Card.Body>
          <Row>
            <Col>
              <Row>
                <Form.Label>Date : {moment(_.get(bundle, 'createdAt')).format('MM-DD-YYYY')}</Form.Label>
              </Row>
                <Row>
                  <Form.Label>Payment Type : {_.get(bundle, 'paymentType')}</Form.Label>
                </Row>
                <Row>
                  <Form.Label>Service Type : {_.get(bundle, 'serviceType')}</Form.Label>
                </Row>                
              <Row>
                <Form.Label>Delivery Address : {_.get(bundle, 'deliveryAddress.landmark')}</Form.Label>
              </Row>              
            </Col>
            <Col className={'float-end'}></Col>
            <Col className={'float-end'}>
              <Row>
                  <Form.Label>Account No : {_.get(bundle, 'receiver.accountNo')}</Form.Label>
                </Row>
                <Row>
                  <Form.Label>Phone : {phoneFormat(_.get(bundle, 'receiver')) }</Form.Label>
                </Row>
                <Row>
                  <Form.Label>Name : {nameFormat(_.get(bundle, 'receiver'))}</Form.Label>
                </Row>
            </Col>
          </Row>
          <Row>
            <Table responsive className="table-centered table-nowrap rounded mb-0">
                <thead className="thead-light">
                  <tr>
                    <th className="border-0">#</th>                                        
                    <th className="border-0">Arrived Date</th>                    
                    <th className="border-0">Reference#</th>   
                    <th className="border-0" width={15}></th>   
                    <th className="border-0">Status</th>
                    <th className="border-0">Shipping Fee#</th>                    
                    <th className="border-0">Refund</th>
                  </tr>
                </thead>
                <tbody>
                {
                  _.get(bundle, 'bundleItems') && _.get(bundle, 'bundleItems').map((item, index) => {
                    return (
                      <tr>
                        <td>{index + 1}</td>
                        {_.get(item, 'waybill') && (
                          <>
                          <td>{moment(_.get(item, 'waybill.createdAt')).format('MM-DD-YYYY')}</td>
                          <td>{_.get(item, 'waybill.reference')}</td>
                          <td>
                            {_.get(item, 'waybill.photo') && (
                              <Button onClick={() => setPhoto(_.get(item, 'waybill.photo'))} variant="transparent" size="sm" className="mb-0 fs-10"><FontAwesomeIcon icon={faImage} /></Button> 
                            )}
                          </td>
                          <td><WaybillStatus item={_.get(item, 'waybill')} /></td>
                          <td>{ currencyFormat(_.get(item, 'waybill.freightFee', '0'))}</td>
                          <td>
                          {
                            _.get(item, 'waybill.status') == WaybillStatusType.ARRIVED && 
                            <Button className={"btn btn-sm"} 
                              onClick={()=>{
                                setItem(item)
                                setShowRefund(true)
                                // Swal.fire({
                                //     title: 'Refund?',                                  
                                //     showCancelButton: true,
                                //     confirmButtonText: `Yes`,
                                //   }).then((result) => {
                                //     if (result.isConfirmed) {
                                //       refund(item)
                                //     }
                                //   })   
                                // Swal.fire({
                                //   title: 'Input the joonaak fee',
                                //   input: 'number',
                                //   step: '0.01',
                                //   inputAttributes: {
                                //     autocapitalize: 'off'
                                //   },
                                //   showCancelButton: true,
                                //   confirmButtonText: 'Refund',
                                //   showLoaderOnConfirm: true,
                                //   inputValue: (fee) => {
                                //     console.log(">fee", fee)
                                //     setAdditionalFee(fee) 
                                //   },
                                //   preConfirm: (fee) => {
                                //     console.log(">fee", fee)
                                //     setAdditionalFee(fee) 
                                //   },
                                // }).then((result) => {
                                //   console.log(">result", result)
                                //   if (result.isConfirmed) {
                                //     refund(item)
                                //   }
                                // })
                              }}
                            >
                              <FontAwesomeIcon icon={faFileInvoiceDollar} />
                            </Button>
                          }
                            
                          </td>
                          </>
                        )}
                        {!_.get(item, 'waybill') && (
                          <td colSpan={5}>
                          {_.get(item, 'note', 'Refunded')}
                          </td>                          
                        )}                        

                      </tr>
                    )
                  })                  
                }   
                {
                  _.get(bundle, 'children') && _.get(bundle, 'children').map((child, index) => { 
                    return <>
                      <tr><td colSpan={5} className={'bg-grey'}></td></tr>
                      {
                        _.get(child, 'bundleItems') && _.get(child, 'bundleItems').map((item, index) => {
                          return (
                            <tr>
                              <td>{index + 1}</td>
                              <td>{moment(_.get(item, 'waybill.createdAt')).format('MM-DD-YYYY')}</td>
                              <td>{_.get(item, 'waybill.reference')}</td>
                              <td><WaybillStatus item={_.get(item, 'waybill')} /></td>
                              <td>{ currencyFormat(_.get(item, 'waybill.freightFee', '0'))}</td>
                            </tr>
                          )
                        })
                      }
                    </>                                        
                  })       
                }      
                              
                </tbody>
                
                <tfoot>
                <tr>
                  <td colSpan={5}>Freight Fee</td>
                  <td>{ currencyFormat(_.get(bundle, 'deliveryFee')) }</td>
                  <td></td>
                </tr>
                <tr>
                  <td colSpan={5}>Delivery Fee</td>
                  <td>{ currencyFormat(_.get(bundle, 'joonaakFee')) }</td>
                  <td></td>
                </tr>
                <tr>
                  <td colSpan={5}>Total</td>
                  <td>{ currencyFormat(_.get(bundle, 'totalFee')) }</td>                  
                  <td></td>
                </tr>
                </tfoot>
            </Table>
          </Row>
        </Card.Body>
        <Card.Footer>
        { logs && (
            <div>              
              <Row>                
                <label className="text-title">Logs</label>
                <ul style={{listStyleType: 'none'}}>
                  {_.orderBy(logs, function(o) { return new moment(o.createdAt); }, ['desc']).map(item=>{
                    return <li>
                    <small>{ moment(_.get(item, 'reactedAt')).format('DD MM,YYYY HH:mm:ss')}</small> : <BundleStatus item={item} /> &nbsp; <small>{_.get(item, 'description')}
                    &nbsp;&nbsp;【{_.get(item, 'user.firstName')} {_.get(item, 'user.lastName')}】</small>
                    </li>
                  })}                                    
                </ul>                
              </Row>
            </div>  
          )}
        </Card.Footer>
      </Card>        
      <br></br>      
      {
        (_.get(bundle, 'deliveryAddress.lat') && _.get(bundle, 'deliveryAddress.lng')) && (
          <Card>
            <Card.Header>              
              <p>{_.get(bundle, 'deliveryAddress.landmark')}</p>
              <p>{_.get(bundle, 'deliveryAddress.lat')},{_.get(bundle, 'deliveryAddress.lng')}</p>
            </Card.Header>
            <Card.Body>
                <DeliveryAddressMapView 
                  lat={_.get(bundle, 'deliveryAddress.lat')}
                  lng={_.get(bundle, 'deliveryAddress.lng')}
                />     
            </Card.Body>
          </Card>    
        )
      }      
    </>
  );
};


const DeliveryAddressMapView = (props) => {

  const center = {lat: parseFloat(_.get(props, 'lat')), lng: parseFloat(_.get(props, 'lng'))}
  return (
    <>      
      <MapView
        loadingElement={<div style={{ height: '100%' }} />}
        containerElement={<div style={{ height: '500px' }} />}
        mapElement={<div style={{ height: '100%' }} />}
        center={center}
        zoom={17.0}
      >
        {
          (_.get(props, 'lat') && _.get(props, 'lng')) && (
            <Marker
              options={{
                icon: marker,
              }}
              position={center}
            />
          )
        }

      </MapView>
    </>
  )
}